// Buy-bonus packages -> render-ready view model.
export const toBuyBonusPackagesView = (data, { renderValue }) => ({
  count: data?.count ?? 0,
  rows: (data?.buyBonusPackages ?? []).map((pkg) => ({
    id: pkg.packageId,
    name: pkg.packageName,
    status: pkg.status,
    freebets: pkg.numberOfFreebets,
    stakePerFreebet: renderValue(pkg.stakeAmountPerFreebet),
    price: renderValue(pkg.packageValue),
    packageValue: pkg.packageValue,
    jackpotRatio: pkg.jackpotRatio,
    order: pkg.slabOrder,
    currency: pkg.currency,
  })),
})
